import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { parseColor as $799cddbef784668f$export$6e865ea70d7724f } from "./Color.module.js";
import { useColor as $aa90ad8b2b1d015f$export$5aadd9c0606af5c2 } from "./useColor.module.js";
import { useControlledState as $5GESt$useControlledState } from "@react-stately/utils";

function $309d2b7669014898$export$dc6b73b623f8645f(props) {
  var value = (0, $aa90ad8b2b1d015f$export$5aadd9c0606af5c2)(props.value);
  var defaultValue = (0, $aa90ad8b2b1d015f$export$5aadd9c0606af5c2)(props.defaultValue || '#000000');

  var _ref = (0, $5GESt$useControlledState)(value || undefined, defaultValue, props.onChange),
      _ref2 = _slicedToArray(_ref, 2),
      color = _ref2[0],
      _setColor = _ref2[1];

  return {
    color: color,
    setColor: function setColor(color) {
      if (color != null) _setColor(color || (0, $799cddbef784668f$export$6e865ea70d7724f)('#000000'));
    }
  };
}

export { $309d2b7669014898$export$dc6b73b623f8645f as useColorPickerState };